import React from 'react';
import { Table } from 'semantic-ui-react';
import clsx from 'clsx';
import TableWrapper from '@/components/table/TableWrapper';
import NoRows from '@/components/table/NoRows';
import { propertiesWithValue } from '@/utils/resultsHelper';
import FormObjectsTableColumns from './FormObjectsTableColumns';
import FormObjectsTableRows from './FormObjectsTableRows';

const FormObjectsTable = ({
  addItem,
  allowAdd,
  allowRemove,
  canEdit,
  className,
  code,
  deleteItem,
  field,
  items = [],
  showItem,
  updateProperties,
}) => {
  const onValueChange = (index, fieldName, value) => {
    const properties = propertiesWithValue({ name: fieldName }, value);
    updateProperties({ activeIndex: index, properties });
  };

  return (
    <div className={clsx('aridhia-form-objects-table-wrapper', 'input', field.code, className)}>
      <TableWrapper sticky celled className="aridhia-form-objects-table">
        <Table.Header fullWidth>
          <FormObjectsTableColumns addItem={addItem} allowAdd={allowAdd} canEdit={canEdit} field={field} />
        </Table.Header>
        <Table.Body>
          <FormObjectsTableRows
            allowRemove={allowRemove}
            canEdit={canEdit}
            code={code}
            deleteItem={deleteItem}
            field={field}
            items={items}
            onChange={onValueChange}
            showItem={showItem}
          />
        </Table.Body>
      </TableWrapper>
      {items.length === 0 && (
        <NoRows
          buttonText={field.placeholder}
          className="min-h-35"
          entity="catalogue.object"
          onClick={canEdit ? () => addItem() : undefined}
        />
      )}
    </div>
  );
};

export default FormObjectsTable;
